export function setupProductInspiration() {
    const productInspirations = document.querySelectorAll('.product-inspiration');

    Array.from(productInspirations).forEach(productInspiration => {
        const items = productInspiration.querySelectorAll('.product-inspiration__item');
        const prev = productInspiration.querySelector('.product-inspiration__prev');
        const next = productInspiration.querySelector('.product-inspiration__next');
        const current = productInspiration.querySelector('.product-inspiration__counter__current');
        let activeIndex = 0;

        function updateCurrentItem() {
            items[activeIndex].classList.remove('js-active');
        }

        function updateNewItem(direction) {
            items[activeIndex].classList.add('js-active');

            if (current) {
                current.textContent = parseInt(activeIndex + 1);
                productInspiration.setAttribute('data-active-index',activeIndex);
            }
        }

        function clickPrev() {
            if (activeIndex > 0) {
                updateCurrentItem();
                activeIndex--;
                updateNewItem('prev');
            }
        }

        function clickNext() {
            if (activeIndex + 1 < items.length) {
                updateCurrentItem();
                activeIndex++;
                updateNewItem('next');
            }
        }

        if (prev) {
            prev.addEventListener('click',clickPrev);
        }

        if (next) {
            next.addEventListener('click',clickNext);
        }
    });
}